import {
  Button,
  Dialog,
  DialogContentText,
  Grid,
  IconButton,
  InputLabel,
  TextField,
  Tooltip,
  Typography, Backdrop, Alert, Snackbar, useMediaQuery, CircularProgress 
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Box } from "@mui/system";
import React, { useEffect, useRef } from "react";
import { useState } from "react";
import CustomAutoComplete from "../CustomComponents/CustomAutoComplete";
import CustomTextField from "../CustomComponents/CustomTextField";
import StlapFooter from "../CustomComponents/StlapFooter";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import GetBranchDetails from "../CustomComponents/GetBranchDetails";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import AccordianContainer from "../CustomComponents/AccordianContainer";
import NachApprovalReducer, {
  NachApprovalReducerAction,
} from "../Store/NachApprovalReducer";
import { BranchAction } from "../Store/Branch";
import CustomDateField from "../CustomComponents/CustomDateField";
import store from "../Store";
import { NachModeAction } from "../Store/Nach/NachMode";
import { SpecialAccessDetailAction } from "../Store/SpecialAccess/SpecialAccessDetailReducer";
import dayjs from "dayjs";
import { CommonShortCutAction } from "../Store/CommonShortCutsReducer";
import CustomConfirmationDialog from "../CustomComponents/CustomConfirmationDialog";
import GetBranchDetailsWithCode from "../CustomComponents/GetBranchDetailsWithCode";

const NachActiveDeactive = () => {
  //Getting approval data from Store
  const aprovableData = useSelector((state) => state.nachApproval.approvalData);
  const dueDate = useSelector((state) => state.shortcut.dueDate);

  //Getting Active and DeActive State -> true Activation state -> false DeActivation state
  const activationState = useSelector(
    (state) => state.nachMode.Status.activationState
  );
  const showDetailScreen = useSelector(
    (state) => state.nachApproval.showOrHideComponents.showOrHideDetail
  );
  const mandateDetails = useSelector(
    (state) => state.nachApproval.mandateDetails
  );
  const editLock = useSelector((state) => state.nachApproval.editLock);
  //Setting dispatch state
  const dispatch = useDispatch();
  //Checking verified Status for hiding and disabled fields
  const [activatedStatus, setActivatedStatus] = useState(true);
  const [editLockDialogOpen, setEditLockDialogOpen] = useState();
  const [deActivationDateValue, setDeactivationDateValue] = useState(
    aprovableData.deactivationDate
  );
  //
  //Filter conditions State value
  const [branchArray, setBranchArray] = useState([]);
  const [branchValue, setBranchValue] = useState(null);
  const [applicationArray, setApplicationArray] = useState([]);
  const [applicationValue, setApplicationValue] = useState(null);
  const [applicationStore, setApplicationStore] = useState([]);
  const [mandateArray, setMandateArray] = useState([]);
  const [mandateValue, setMandateValue] = useState(null);
  const [escapeDialogCloseValue, setEscapeDialogCloseValue] = useState("");
  //State to maintain Discard changes
  const [mode, setMode] = useState("");
  const [selectedData, setSelectedData] = useState("");
  //Dialog Title for Success
  const [successTitle, setSuccessTitle] = useState("");
  //Success Dialog Message Handler
  const [sucessDialogOpen, setSuccessDialogOpen] = useState(false);
  //Handle Sucess Dialog Message
  const [successDialogMessage, setSuccessDialogMessage] = useState("");
  const [accessDialogOpen, setAccessDialogOpen] = useState(false);
  const handlerSuccessDialogClose = () => {
    setSuccessDialogOpen(false);
  };
  //Reset Dialog State value
  const [resetDialogHandler, setResetDialogHandler] = useState(false);
  //Save Button enable and disable
  const [saveButtonEnable, setSaveButtonEnable] = useState(true);
  //Status to maintain edit lock
  const [editLockStatus, setEditLockStatus] = useState();
  const [umrnNumber, setUmrnNumber] = useState("");
  //Getting state value for comparision
  const initialDeActivationDateReason = useSelector(
    (state) => state.nachApproval.initialDeActivationDateReason
  );
  const updateDeActivationDateReason = useSelector(
    (state) => state.nachApproval.updateDeActivationDateReason
  );
  //Vaidation section for status fields
  const [showDEActivatedFlag, setShowDEActivatedFlag] = useState(false);
  const branchIsValid = branchValue !== "" && branchValue !== null;
  const applicationNumIsValid =
    applicationValue !== "" && applicationValue !== null;
  const mandataIsValid = mandateValue !== "" && mandateValue !== null;
  const umrnNumberIsValid = umrnNumber !== "" && umrnNumber !== null;

  //fLAG CHECK
  var today = new Date();
  var givenYear = new Date(aprovableData.deactivationDate).getFullYear();
  var givenMonth = new Date(aprovableData.deactivationDate).getMonth() + 1; // Adding 1 because month is zero-based
  var givenDay = new Date(aprovableData.deactivationDate).getDate();

  //Bulk Upload Download state and field
  const [loading, setLoading] = useState(false);
  const [loadingMsg, setLoadingMsg] = useState("");
  const [bulkDlgOpen, setBulkDlgOpen] = useState(false);
  const [actDeact, setActDeact] = useState([{label:"Activation"}, {label:"Deactivation"}])
  const [actDeactVal, setActDeactVal] = useState(null);
  const [actDeactIsTouched, setactDeactIsTouched] = useState(false);
  const actDeactIsValid = actDeactVal!==null && actDeactVal!=="" 
  const actDeactHasError = actDeactIsTouched && !actDeactIsValid;
  
  const [message, setMessage] = useState("");
  const [alertType, setAlertType] = useState("success");
  const [snackBarState, setSnackBarState] = React.useState({
    vertical: "bottom",
    horizontal: "left",
  });
  const { vertical, horizontal } = snackBarState;
  const [alert, setAlert] = useState(false);

  const deviceModeValue = useMediaQuery("(max-width:1200px)");
  useEffect(() => {
    // true -> mobile or tab, false -> desktop
    let SnackPosition = {
      vertical: deviceModeValue ? "top" : "bottom",
      horizontal: deviceModeValue ? "right" : "left",
    };
    setSnackBarState(SnackPosition);
  }, []);

  // Extract year, month, and day values from today's date
  var todayYear = today.getFullYear();
  var todayMonth = today.getMonth() + 1;
  var todayDay = today.getDate();

  let deactivationDateValidationFlag;
  if (givenYear > todayYear) {
    deactivationDateValidationFlag = true;
  } else if (givenYear === todayYear && givenMonth > todayMonth) {
    deactivationDateValidationFlag = true;
  } else if (
    givenYear === todayYear &&
    givenMonth === todayMonth &&
    givenDay >= todayDay
  ) {
    deactivationDateValidationFlag = true;
  } else {
    deactivationDateValidationFlag = false;
  }

  const deactivationDateIsValid =
    new Date(aprovableData.deactivationDate).toDateString() !==
      "Invalid Date" &&
    aprovableData.deactivationDate !== null &&
    new Date(aprovableData.deactivationDate).toLocaleDateString().slice(-4) >=
      "1970" &&
    new Date(aprovableData.deactivationDate).toLocaleDateString().slice(-4) <=
      "2055" &&
    deactivationDateValidationFlag;

  const deactivationReasonIsValid =
    aprovableData.deactivationReason.trim() !== "" &&
    aprovableData.deactivationReason !== null &&
    aprovableData.deactivationReason.length <= 4000;

  const [showActivateButtonDetails, setShowActivateButtonDetails] = useState();
  const [branchIsTouched, setBranchIsTouched] = useState(false);
  const [applicationIsTouched, setApplicationTouched] = useState(false);
  const [mandateIsTouched, setMandateIsTouched] = useState(false);
  const [urmnNumberIsTouched, setUrmnNumberIsTouched] = useState(false);
  const [deactivationReasonIsTouched, setDeactivationReasonIsTouched] =
    useState(false);
  const [deactivationDateIsTouched, setDeactivationDateIsTouched] =
    useState(false);
  const [specialAccessCheck, setSpecialAccessCheck] = useState(false);

  const branchHasError = branchIsTouched && !branchIsValid;
  const applicationHasError = applicationIsTouched && !applicationNumIsValid;
  const mandateHassError = mandateIsTouched && !mandataIsValid;
  const umrnNumberHasError = urmnNumberIsTouched && !umrnNumberIsValid;
  const deactivationReasonHasError =
    deactivationReasonIsTouched && !deactivationReasonIsValid;
  const deactivationDateHasError =
    deactivationDateIsTouched && !deactivationDateIsValid;
  let compareTwoArrayOfObjects = (obj1, obj2) => {
    return (
      obj1.length === obj2.length &&
      obj1.every((element_1) =>
        obj2.some((element_2) =>
          Object.keys(element_1).every(
            (key) => element_1[key] === element_2[key]
          )
        )
      )
    );
  };

  const userId = store.getState().branch.userID;
  const moduleId = useSelector((state) => state.specialAccess.moduleId);
  const programId = useSelector((state) => state.specialAccess.programId);
  let fieldAccessMap = useSelector(
    (state) => state.specialAccess.fieldAccessMap
  );
  let paramValues = useSelector((state) => state.specialAccess.paramValues);

  //Branch onChangeHandler
  useEffect(() => {
    getFieldData();
  }, []);

  const getFieldData = async () => {
    let modeIdVal = "";
    const response = await axios.get("/specialAccess/getFieldAccess", {
      method: "get",
      params: {
        userId: userId,
        moduleId: moduleId,
        programId: programId,
        modeId: modeIdVal,
      },
    });
    dispatch(SpecialAccessDetailAction.getFieldData(response.data));
  };

  let maxDateAddValue = Number(0);
  if (
    paramValues !== null &&
    paramValues !== undefined &&
    Object.keys(paramValues).length > 0
  ) {
    if (
      !(
        paramValues["Nach Approval Request Date Future Count"] &&
        new Date(
          paramValues["Nach Approval Request Date Future Count"][
            "paramEffStartDate"
          ]
        ) <= new Date(dayjs(new Date()).format("MM/DD/YYYY")) &&
        new Date(
          paramValues["Nach Approval Request Date Future Count"][
            "paramEffEndDate"
          ]
        ) >= new Date(dayjs(new Date()).format("MM/DD/YYYY"))
      )
    ) {
      maxDateAddValue = 0;
    } else {
      maxDateAddValue =
        fieldAccessMap.nachApprovalDate &&
        fieldAccessMap.nachApprovalFutureCount
          ? Number(
              paramValues["Nach Approval Request Date Future Count"][
                "paramValue"
              ]
            )
          : Number(0);
    }
  }

  const saveRef = useRef(null);
  const searchButtonRef = useRef(null);
  const cancelRef = useRef(null);
  const yesRef = useRef(null);
  const okRef = useRef(null);
  const okEditRef = useRef(null);
  const clearRef = useRef(null);
  const cancelResetRef = useRef(null);
  const okResetRef = useRef(null);
  const viewRef = useRef(null);

  const onKeyUnmountEventHandler = (event) => {
    if (event.ctrlKey) {
      dispatch(
        CommonShortCutAction.removeDefaultShortCutValue({
          event: event,
          screen: "nachApproval",
        })
      );
    }
  };

  //Methods
  const branchOnChangeHandler = (value) => {
    setMode("BranchMode");
    setSelectedData(value);
    if (showDetailScreen) {
      const result = compareTwoArrayOfObjects(
        [initialDeActivationDateReason],
        [updateDeActivationDateReason]
      );
      if (!result) {
        setResetDialogHandler(true);
      } else {
        let { editLockFlag, branch, applicationNumber } = editLock;
        if (!editLockFlag) {
          releaseLock(branch, applicationNumber);
        }
        // const applicationArray = applicationStore.filter((item) => {
        //   return item.branch === value.label;
        // });
        // const app = applicationArray.map((itm) => itm.applicationNum).sort();
        // setApplicationArray([...new Set(app)]);
        dispatch(NachApprovalReducerAction.resetValues());
        setSaveButtonEnable(true);
        setDeactivationDateIsTouched(false);
        setDeactivationReasonIsTouched(false);
        //setApplicationArray([]);
        // setApplicationTouched(false);
        if (value !== null) {
          getApplicationNumberByBranch(value.label);
          dispatch(NachApprovalReducerAction.updateEditLockBranch(value.label));

          dispatch(BranchAction.updateInitialLoad(false));
          dispatch(BranchAction.updateHeaderBranchDetails(value.label));
        }
        setApplicationValue("");
        setMandateArray([]);
        setApplicationArray([]);
        // setMandateValue("");
        setUmrnNumber("");
        // setMandateIsTouched(false);
        setBranchValue(value == null ? "" : value.label);
      }
    } else {
      let { editLockFlag, branch, applicationNumber } = editLock;
      if (!editLockFlag) {
        releaseLock(branch, applicationNumber);
      }
      // const applicationArray = applicationStore.filter((item) => {
      //   return item.branch === value.label;
      // });
      // const app = applicationArray.map((itm) => itm.applicationNum).sort();
      // setApplicationArray([...new Set(app)]);
      dispatch(NachApprovalReducerAction.resetValues());
      setSaveButtonEnable(true);
      setDeactivationDateIsTouched(false);
      setDeactivationReasonIsTouched(false);
      //setApplicationArray([]);
      // setApplicationTouched(false);
      if (value !== null) {
        getApplicationNumberByBranch(value.label);
        dispatch(NachApprovalReducerAction.updateEditLockBranch(value.label));

        dispatch(BranchAction.updateInitialLoad(false));
        dispatch(BranchAction.updateHeaderBranchDetails(value.label));
      }
      setApplicationValue("");
      setMandateArray([]);
      setApplicationArray([]);
      setMandateValue("");
      setUmrnNumber("");
      // setMandateIsTouched(false);
      setBranchValue(value == null ? "" : value.label);
    }
  };
  const accessDialogClickHandler = () => {
    setAccessDialogOpen(false);
    showActivatedButtonHandler();
  };
  const onOkButtonClickHandler = () => {
    if (mode === "BranchMode") {
      let { editLockFlag, branch, applicationNumber } = editLock;
      if (!editLockFlag) {
        releaseLock(branch, applicationNumber);
      }
      // const applicationArray = applicationStore.filter((item) => {
      //   return item.branch === value.label;
      // });
      // const app = applicationArray.map((itm) => itm.applicationNum).sort();
      // setApplicationArray([...new Set(app)]);
      dispatch(NachApprovalReducerAction.resetValues());
      setSaveButtonEnable(true);
      setDeactivationDateIsTouched(false);
      setDeactivationReasonIsTouched(false);
      //setApplicationArray([]);
      // setApplicationTouched(false);
      if (selectedData !== null) {
        getApplicationNumberByBranch(selectedData.label);
        dispatch(
          NachApprovalReducerAction.updateEditLockBranch(selectedData.label)
        );

        dispatch(BranchAction.updateInitialLoad(false));
        dispatch(BranchAction.updateHeaderBranchDetails(selectedData.label));
      }
      setApplicationValue("");
      setMandateArray([]);
      setApplicationArray([]);
      setMandateValue("");
      setUmrnNumber("");
      // setMandateIsTouched(false);
      setBranchValue(selectedData == null ? "" : selectedData.label);
    }
    if (mode === "ApplicationNumberMode") {
      let { editLockFlag, branch, applicationNumber } = editLock;
      if (!editLockFlag) {
        releaseLock(branch, applicationNumber);
      }
      setSaveButtonEnable(true);
      setDeactivationDateIsTouched(false);
      setDeactivationReasonIsTouched(false);
      dispatch(NachApprovalReducerAction.resetValues());
      dispatch(
        NachApprovalReducerAction.updateEditLockApplicationNumber(selectedData)
      );
      getMandateNumberBasedOnApplicationNumber(selectedData);
      setApplicationValue(selectedData);
      setMandateArray([]);
      setMandateValue("");
      setUmrnNumber("");
    }
    if (mode === "MandateNumberMode") {
      dispatch(NachApprovalReducerAction.resetValues());
      // setRemarkValue("");
      setSaveButtonEnable(true);
      setDeactivationDateIsTouched(false);
      setDeactivationReasonIsTouched(false);
      setMandateValue(selectedData);
      setUmrnNumber("");
      try {
        changeAppNumReq(selectedData);
      } catch {}
    }
    if (mode === "ClearMode") {
      dispatch(NachApprovalReducerAction.resetValues());
      setApplicationValue("");
      setMandateArray([]);
      setApplicationArray([]);
      setMandateValue("");
      setUmrnNumber("");
      setBranchValue(null);
      setBranchIsTouched(false);
      setApplicationTouched(false);
      setMandateIsTouched(false);
      setUrmnNumberIsTouched(false);
      setSaveButtonEnable(true);
    }
    setResetDialogHandler(false);
  };
  const clearButtonHandler = () => {
    setMode("ClearMode");
    if (showDetailScreen) {
      const result = compareTwoArrayOfObjects(
        [initialDeActivationDateReason],
        [updateDeActivationDateReason]
      );
      if (!result) {
        setResetDialogHandler(true);
      } else {
        dispatch(NachApprovalReducerAction.resetValues());
        setApplicationValue("");
        setMandateArray([]);
        setApplicationArray([]);
        setMandateValue("");
        setUmrnNumber("");
        setBranchValue(null);
        setBranchIsTouched(false);
        setApplicationTouched(false);
        setMandateIsTouched(false);
        setUrmnNumberIsTouched(false);
        setSaveButtonEnable(true);
      }
    } else {
      dispatch(NachApprovalReducerAction.resetValues());
      setApplicationValue("");
      setMandateArray([]);
      setApplicationArray([]);
      setMandateValue("");
      setUmrnNumber("");
      setBranchValue(null);
      setBranchIsTouched(false);
      setApplicationTouched(false);
      setMandateIsTouched(false);
      setUrmnNumberIsTouched(false);
      setSaveButtonEnable(true);
    }
  };

  const getSelectedBranchCode = (branchValue) => {
    const branchWithCodes = GetBranchDetailsWithCode();
    const branchCodeValue = branchWithCodes.find((branch) => {
      return branch.label === branchValue;
    });
    return branchCodeValue.code;
  };

  const getApplicationNumberByBranch = async (value) => {
    let reqParams;

    reqParams = ["VERIFIED", "ACTIVATED", "DEACTIVATED"];
    const branchCodeValue = getSelectedBranchCode(value);

    const response = await axios.post("/nach/getApplicationNumByBranch", {
      branch: value,
      branchCode: branchCodeValue,
      status: reqParams,
    });
    setApplicationArray(response.data.sort());
  };
  const applicationNumberOnChangeHandler = (value) => {
    setMode("ApplicationNumberMode");
    setSelectedData(value);
    if (showDetailScreen) {
      const result = compareTwoArrayOfObjects(
        [initialDeActivationDateReason],
        [updateDeActivationDateReason]
      );
      if (!result) {
        setResetDialogHandler(true);
      } else {
        let { editLockFlag, branch, applicationNumber } = editLock;
        if (!editLockFlag) {
          releaseLock(branch, applicationNumber);
        }
        setSaveButtonEnable(true);
        setDeactivationDateIsTouched(false);
        setDeactivationReasonIsTouched(false);
        dispatch(NachApprovalReducerAction.resetValues());
        dispatch(
          NachApprovalReducerAction.updateEditLockApplicationNumber(value)
        );
        getMandateNumberBasedOnApplicationNumber(value);
        setApplicationValue(value);
        setMandateArray([]);
        setMandateValue("");
        setUmrnNumber("");
        // setMandateIsTouched(false);

        // const mandateArray = applicationStore.filter((item) => {
        //   return value === item.applicationNum;
        // });
        // const arr = mandateArray.map((itm) => {
        //   return {
        //     label: `${itm.mandateNum} - ${itm.applicantName}`,
        //     value: itm.mandateNum,
        //   };
        // });
        // setMandateArray(arr);
      }
    } else {
      let { editLockFlag, branch, applicationNumber } = editLock;
      if (!editLockFlag) {
        releaseLock(branch, applicationNumber);
      }
      setSaveButtonEnable(true);
      setDeactivationDateIsTouched(false);
      setDeactivationReasonIsTouched(false);
      dispatch(NachApprovalReducerAction.resetValues());
      dispatch(
        NachApprovalReducerAction.updateEditLockApplicationNumber(value)
      );
      getMandateNumberBasedOnApplicationNumber(value);
      setApplicationValue(value);
      setMandateArray([]);
      setMandateValue("");
      setUmrnNumber("");
      // setMandateIsTouched(false);

      // const mandateArray = applicationStore.filter((item) => {
      //   return value === item.applicationNum;
      // });
      // const arr = mandateArray.map((itm) => {
      //   return {
      //     label: `${itm.mandateNum} - ${itm.applicantName}`,
      //     value: itm.mandateNum,
      //   };
      // });
      // setMandateArray(arr);
    }
  };
  const getMandateNumberBasedOnApplicationNumber = async (value) => {
    let reqParams;
    reqParams = ["VERIFIED", "ACTIVATED", "DEACTIVATED"];
    const response = await axios.post("/nach/getMandateNumByAppNum", {
      applicationNum: value,
      status: reqParams,
    });
    let lockStatus = response.data[0].editLock;
    dispatch(NachApprovalReducerAction.updateEditLockFlag(lockStatus));
    setEditLockStatus(lockStatus);
    const arr = response.data.map((itm) => {
      return itm.mandateNum;
    });
    setMandateArray(arr);
  };
  //Sumbit button Handler
  const submitButtonOnChangeHandler = () => {
    setBranchIsTouched(true);
    setApplicationTouched(true);
    setMandateIsTouched(true);
    setUrmnNumberIsTouched(true);
    let valid;
    if (activationState) {
      valid =
        branchIsValid &&
        applicationNumIsValid &&
        mandataIsValid &&
        umrnNumberIsValid;
    } else {
      setDeactivationReasonIsTouched(true);
      setDeactivationDateIsTouched(true);
      valid =
        branchIsValid &&
        applicationNumIsValid &&
        mandataIsValid &&
        umrnNumberIsValid &&
        deactivationDateIsValid &&
        deactivationReasonIsValid;
    }
    if (valid) {
      setEscapeDialogCloseValue("Confirmation");
      setconfirmationDialogOpen(true);
    }
  };
  const mandateNumberOnChangeHandler = (value) => {
    setMode("MandateNumberMode");
    setSelectedData(value);
    if (showDetailScreen) {
      const result = compareTwoArrayOfObjects(
        [initialDeActivationDateReason],
        [updateDeActivationDateReason]
      );
      if (!result) {
        setResetDialogHandler(true);
      } else {
        dispatch(NachApprovalReducerAction.resetValues());
        // setRemarkValue("");
        setSaveButtonEnable(true);
        setDeactivationDateIsTouched(false);
        setDeactivationReasonIsTouched(false);
        setMandateValue(value);
        try {
          changeAppNumReq(value);
        } catch {}
      }
    } else {
      dispatch(NachApprovalReducerAction.resetValues());
      // setRemarkValue("");
      setSaveButtonEnable(true);
      setDeactivationDateIsTouched(false);
      setDeactivationReasonIsTouched(false);
      setMandateValue(value);
      try {
        changeAppNumReq(value);
      } catch {}
    }
  };
  //Handling dialogs for confirmation modal
  const [confirmationDialogOpen, setconfirmationDialogOpen] = useState(false);
  const confirmationDialogClose = () => {
    setconfirmationDialogOpen(false);
  };
  const confirmationDialogOkButtonClickHandler = () => {
    try {
      statusUpdation();
    } catch {}
  };

  //Status updating on submit
  const statusUpdation = async () => {
    let response;
    if (activationState) {
      response = await axios.post("/nach/nachStatusChange", {
        mandateNum: mandateValue,
        applicationNum: aprovableData.applicationNum,
        status: "ACTIVATED",
        mode: "ACTIVATED",
        remarks: "",
        umrnNumber: umrnNumber,
        deActivatedDate: null,
      });
    } else {
      response = await axios.post("/nach/nachStatusChange", {
        mandateNum: mandateValue,
        applicationNum: aprovableData.applicationNum,
        status: "DEACTIVATED",
        mode: "DEACTIVATED",
        remarks: aprovableData.deactivationReason,
        deActivatedDate: new Date(
          aprovableData.deactivationDate
        ).toLocaleDateString(),
      });
    }
    if (response.status == 200) {
      setconfirmationDialogOpen(false);
      setSuccessDialogMessage(
        `NACH Mandate ${
          activationState ? "Activated" : "Deactivated"
        } Successfully.`
      );
      dispatch(NachModeAction.updateActivationState(null));

      setShowActivateButtonDetails(false);
      setActivatedStatus(true);
      setSuccessTitle("Information");
      setEscapeDialogCloseValue("InformationSuccess");
      setSuccessDialogOpen(true);
      setBranchValue("");
      setApplicationValue("");
      dispatch(NachApprovalReducerAction.resetValues());
      setApplicationArray([]);
      setMandateArray([]);
      setMandateValue("");
      setUmrnNumber("");
      setMandateIsTouched(false);
      setUrmnNumberIsTouched(false);
      setBranchIsTouched(false);
      setApplicationTouched(false);
      setDeactivationReasonIsTouched(false);
      setDeactivationDateIsTouched(false);
      setSaveButtonEnable(true);
    } else if (response.status == 206) {
      setconfirmationDialogOpen(false);
      setSuccessDialogMessage(
        `NACH Mandate ${
          activationState ? "Activated" : "Deactivation "
        } Not Allowed Since Mandate is already in Retrieve or Posting Status.`
      );
      setSuccessTitle("Information");
      setEscapeDialogCloseValue("InformationSuccess");
      setSuccessDialogOpen(true);
    }
  };
  const showActivatedButtonHandler = () => {
    setSaveButtonEnable(true);

    setBranchIsTouched(true);
    setApplicationTouched(true);
    setMandateIsTouched(true);
    setUrmnNumberIsTouched(true);
    setShowDEActivatedFlag(false);
    let valid;
    if (activationState) {
      valid =
        branchIsValid &&
        applicationNumIsValid &&
        mandataIsValid &&
        umrnNumberIsValid;
    } else {
      valid =
        branchIsValid &&
        applicationNumIsValid &&
        mandataIsValid &&
        umrnNumberIsValid;
    }
    if (valid) {
      dispatch(NachApprovalReducerAction.updateShowOrHideDetail(true));
    }
  };
  const specialAccessHeaderMap = useSelector(
    (state) => state.specialAccess.specialAccessHeaderMap
  );

  //Getting data based on application num
  const changeAppNumReq = async (value) => {
    try {
      const response = await axios.post("/nach/getNachData", {
        mandateNum: value,
      });
      // if (
      //   response.data.status === "ACTIVATED" ||
      //   response.data.status === "VERIFIED"
      // ) {
      //   dispatch(NachModeAction.updateActivationState(true));
      // } else {
      //   dispatch(NachModeAction.updateActivationState(false));
      // }
      if (response.data.status === "VERIFIED") {
        if (specialAccessHeaderMap.nachActivation) {
          dispatch(NachModeAction.updateActivationState(true));
          setActivatedStatus(false);
          setShowActivateButtonDetails(false);
        } else {
          setAccessDialogOpen(true);
          setActivatedStatus(true);
        }
      }
      if (response.data.status === "ACTIVATED") {
        if (specialAccessHeaderMap.nachDeactivation) {
          dispatch(NachModeAction.updateActivationState(false));
          setActivatedStatus(false);
          setShowActivateButtonDetails(true);
        } else {
          setAccessDialogOpen(true);
          setActivatedStatus(true);
        }
      }
      if (response.data.status === "DEACTIVATED") {
        dispatch(NachModeAction.updateActivationState(false));
        setActivatedStatus(true);
        setShowActivateButtonDetails(false);
      }
      if (editLockStatus) {
        setEscapeDialogCloseValue("EditLockDialog");
        setEditLockDialogOpen(true);
      }

      dispatch(
        NachApprovalReducerAction.updateDeactivationDate(
          response.data.deActivationDate
        )
      );
      dispatch(
        NachApprovalReducerAction.updateDeactivationReason(
          response.data.deactivationRemarks
        )
      );
      dispatch(
        NachApprovalReducerAction.updateInitialDeactivationDateReason(
          response.data
        )
      );
      dispatch(NachApprovalReducerAction.updateValues(response.data));
      setUmrnNumber(response.data.umrnNumber);
      dispatch(NachApprovalReducerAction.updateMandateDetails(response.data));
    } catch {}
  };
  //Getting app number
  const getData = async () => {
    let reqParams;
    if (activationState) {
      reqParams = ["VERIFIED", "ACTIVATED"];
    } else {
      reqParams = ["ACTIVATED", "DEACTIVATED"];
    }

    const response = await axios.post(
      "/nach/getAppNumAndBranchByStatus",
      reqParams
    );

    setApplicationStore(response.data);
  };
  useEffect(() => {
    //dueDate !== "" && setDeactivationDateValue(dueDate);
    window.addEventListener("keydown", onKeyUnmountEventHandler);
    window.addEventListener("keyup", onKeyPressEventHandler);
    return () => {
      window.removeEventListener("keydown", onKeyUnmountEventHandler);
      window.removeEventListener("keyup", onKeyPressEventHandler);
    };
  }, [activationState, escapeDialogCloseValue]);
  useEffect(() => {
    dispatch(NachModeAction.updateActivationState(null));
    dispatch(NachApprovalReducerAction.resetValues());
    const branchArr = GetBranchDetails();
    setBranchArray(branchArr);
    //This useEffect for Page refresh
    window.addEventListener("beforeunload", alertUser);
    window.addEventListener("unload", call);
    return () => {
      window.removeEventListener("beforeunload", alertUser);
      window.removeEventListener("unload", call);
      // Method will call when the component unmount
      let branchValue = store.getState().nachApproval.editLock.branch;
      let applicationNumber =
        store.getState().nachApproval.editLock.applicationNumber;
      let editLockFlag = store.getState().nachApproval.editLock.editLockFlag;
      if (!editLockFlag) {
        releaseLock(branchValue, applicationNumber);
      }
    };
  }, []);
  const alertUser = (event) => {
    event.preventDefault();
    event.returnValue = "";
  };
  const call = () => {
    let editLockFlag = store.getState().nachApproval.editLock.editLockFlag;
    let branchValue = store.getState().nachApproval.editLock.branch;
    let applicationNumber =
      store.getState().nachApproval.editLock.applicationNumber;
    if (!editLockFlag) {
      releaseLock(branchValue, applicationNumber);
    }
  };
  const releaseLock = async (branch, applicationNumber) => {
    if (branch !== "" && applicationNumber !== "") {
      try {
        const branchCodeValue = getSelectedBranchCode(branch);
        const response = await axios.post("/nach/editLockUpdate", {
          applicationBranch: branch,
          applicationBranchCode: branchCodeValue,
          applicationNum: applicationNumber,
        });
      } catch {}
    }
  };
  const onKeyPressEventHandler = (event) => {
    if (event.key === "Escape" || event.keyCode === 27) {
      // on escape press close the dialog.

      switch (escapeDialogCloseValue) {
        case "Confirmation":
          confirmationDialogClose();
          break;
        case "InformationSuccess":
          setSuccessDialogOpen(false);
          break;
        case "EditLockDialog":
          editLockOkButonHandler();
          break;
        default:
          break;
      }
    }
    let refList = {
      //clearRef: clearRef,
      cancelRef: cancelRef,
      yesRef: yesRef,
      okRef: okRef.current !== null ? okRef : null,
      saveRef: saveRef,
      okEditRef: okEditRef.current !== null ? okEditRef : null,
      cancelResetRef: cancelResetRef.current !== null ? cancelResetRef : null,
    };
    let date = new Date();
    let charCode = String.fromCharCode(event.which).toLowerCase();
    if (event.ctrlKey) {
      if (charCode === "f") {
        searchButtonRef.current.click();
      } else if (charCode === "k" && okResetRef.current !== null) {
        okResetRef.current.click();
      } else if (charCode === "e") {
        viewRef.current.click();
      } else if (charCode === "d") {
        clearRef.current !== null && clearRef.current.click();
      } else if (charCode === "o") {
        date.setDate(date.getDate() + 1);
        dispatch(NachApprovalReducerAction.updateDeactivationDate(date));
      } else if (charCode === "i") {
        dispatch(NachApprovalReducerAction.updateDeactivationDate(date));
      } else {
        dispatch(
          CommonShortCutAction.getShortCutValue({
            event: event,
            refs: refList,
            screen: "nachApproval",
          })
        );
      }
    }
  };
  const DetailButtonHandler = () => {
    setBranchIsTouched(true);
    setApplicationTouched(true);
    setMandateIsTouched(true);
    setUrmnNumberIsTouched(true);
    setShowDEActivatedFlag(true);
    let valid;
    if (activationState) {
      valid =
        branchIsValid &&
        applicationNumIsValid &&
        mandataIsValid &&
        umrnNumberIsValid;
    } else {
      valid =
        branchIsValid &&
        applicationNumIsValid &&
        mandataIsValid &&
        umrnNumberIsValid;
    }
    if (valid) {
      setSaveButtonEnable(false);
      dispatch(NachApprovalReducerAction.updateShowOrHideDetail(true));
    }
  };
  const editLockOkButonHandler = () => {
    setActivatedStatus(true);
    setEditLockDialogOpen(false);
  };

  //Bulk upload start
  const BulkButtonHandler = () => {
    //setBranchIsTouched(true);
    //setApplicationTouched(true);
    //setMandateIsTouched(true);
    //setUrmnNumberIsTouched(true);
    //let valid = branchIsValid && applicationNumIsValid && mandataIsValid && umrnNumberIsValid;
    //if (valid)
      setBulkDlgOpen(true)
  }
  const onBulkCancelClick = () => {
    setactDeactIsTouched(false)
    setActDeactVal("")
    setBulkDlgOpen(false)
  }
  const statusOnChangeHandler = (value) => {
    setActDeactVal(value == null ? "" : value.label)
  }

  const handleDownload = () => {
    setactDeactIsTouched(true)
    let filenm = ""
    if (actDeactIsValid) {
      let api = "";
      if (actDeactVal === "Activation") {
        api = "nachBulkActivateDeactivate/downloadActivateTemplate"
        filenm = "NACH_Activate_Upload"
      } else if (actDeactVal === "Deactivation") {
        api = "nachBulkActivateDeactivate/downloadDeactivateTemplate"
        filenm = "NACH_Deactivate_Upload"
      }
      let msg = "File Downloaded Success"
      let alertType = "success"
      fileDownload(api, filenm, msg, alertType)
    }
  }

  const handleDwnldVerified = () =>{
    let api = "nachBulkActivateDeactivate/downloadVerifiedTemplate"
    let filenm = `NACH_verified_records__`
    let msg = "File Downloaded Success"
    let alertType = "success"
    fileDownload(api, filenm, msg, alertType)
  }

  const handleDwnldActivated = () =>{
    let api = "nachBulkActivateDeactivate/downloadActivatedTemplate"
    let filenm = `NACH_activated_records__`
    let msg = "File Downloaded Success"
    let alertType = "success"
    fileDownload(api, filenm, msg, alertType)
  }

  const fileDownload = (api, filenm, msg, alertType) =>{
    try {
      setLoading(true)
      setLoadingMsg("Downloading File")
      axios.get(api, { responseType: 'blob' })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filenm + `.xlsx`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setLoading(false)
        setLoadingMsg("")
        setMessage(msg);
        setAlertType(alertType);
        openAlertHandler();
      })
    } catch (error) {
      setLoading(false)
      setLoadingMsg("")
      setMessage("File Download Failed.");
      setAlertType("error");
      openAlertHandler();
      throw Error(error);
    }
  }

  const onClickHandler = () => {
    setactDeactIsTouched(true)
    if (actDeactIsValid) {
      document.getElementById('fileUpload').click()
    }
  }

  const handleUpload = async (event) => {
    let uploadApi = '';
    let uploadErrApi = '';
    let errFileNm = ""
    const file = event.target.files[0];
    const formData = new FormData();
    formData.append("file", file);
    let element = document.getElementById("fileUpload");
    element.value = null;

    if (!file.name.includes(".xls")) {
      setMessage("Format not supported");
      setAlertType("error");
      openAlertHandler();
      throw new Error("Format not supported")
    }

    if (actDeactVal === "Activation") {
      uploadApi = "nachBulkActivateDeactivate/uploadNachActivateUpload"
      errFileNm = "NACH_Activate_ErrorData"
    } else if (actDeactVal === "Deactivation") {
      uploadApi = "nachBulkActivateDeactivate/uploadNachDeActivateUpload"
      errFileNm = "NACH_Deactivate_ErrorData"
    }

    try {
      setLoading(true)
      setLoadingMsg("File Uploading inprogress")
      const response = await axios.post(uploadApi, formData,{ responseType: 'blob' })
      if (response.status === 200) {
        setLoading(false)
        setLoadingMsg("")
        setMessage("File Upload Success");
        setAlertType("success");
        openAlertHandler();
        onBulkCancelClick()
      }
      if (response.status === 206) {
        setLoading(false)
        setLoadingMsg("")
        setMessage("File already available");
        const filename = errFileNm + `.xlsx`;
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setMessage("Error data Downloaded.");
        setAlertType("error");
        openAlertHandler();
      }
    } catch (error) {
      if (error.response.status === 400 || error.response.status === 500) {
        if (actDeactVal === "Activation") {
          uploadErrApi = "nachBulkActivateDeactivate/nachActivateErrorCheck"
        } else if (actDeactVal === "Deactivation") {
          uploadErrApi = "nachBulkActivateDeactivate/nachDeActivateErrorCheck"
        }
        try {
          const errorResponse = await axios.post(uploadErrApi, formData)
          if (errorResponse.status === 206) {
            setLoading(false)
            setLoadingMsg("")
            setMessage(errorResponse.data);
            setAlertType("error");
            openAlertHandler();
          }
        } catch (error) {
          if (error.response.status === 400 || error.response.status === 500) {
            setLoading(false)
            setLoadingMsg("")
            setMessage("Server Error in processing the uploaded file");
            setAlertType("error");
            openAlertHandler();
          } else {
            setLoading(false)
            setLoadingMsg("")
            setMessage("Network error");
            setAlertType("error");
            openAlertHandler();
          }
        }
      } else {
        setLoading(false)
        setLoadingMsg("")
        setMessage("Network error");
        setAlertType("error");
        openAlertHandler();
      }
    }
  }

  const openAlertHandler = () => {
    setAlert(true);
  };
  const closeAlertHandler = () => {
    setAlert(false);
  };
  //Bulk upload end

  return (
    <React.Fragment>
      <Box style={{ minHeight: "calc(100vh - 120px)" }}>
        <Box>
          <AccordianContainer
            title={
              activationState === null
                ? "NACH Activation / Deactivation"
                : activationState
                ? "Activation"
                : "Deactivation"
            }
            initialOpen={true}
            sx={{ margin: "8px !important" }}
          >
            <Box
              sx={{
                marginBottom: "8px",
                marginTop: "-1%",
                display: "flex",
                gap: "8px",
                justifyContent: "flex-end",
              }}
            >
              {showActivateButtonDetails && (
                <Tooltip title="Ctrl+E" placement="top">
                  <IconButton
                    aria-label="View"
                    color="primary"
                    onClick={showActivatedButtonHandler}
                    ref={viewRef}
                  >
                    <VisibilityIcon />
                  </IconButton>
                </Tooltip>
              )}
            </Box>
            <Box sx={{ marginTop: "-1%" }}>
              <Grid container rowSpacing={0} columnSpacing={2}>
                <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                  <CustomAutoComplete
                    variant="standard"
                    type="text"
                    placeholder="Select Branch"
                    label="Branch"
                    autoCompleteValues={branchArray}
                    value={branchValue ? branchValue : null}
                    required={true}
                    onBlur={() => {
                      setBranchIsTouched(true);
                    }}
                    onChange={(e, value) => {
                      branchOnChangeHandler(value);
                    }}
                  />
                  {branchHasError && (
                    <p className="error">Please Select Branch</p>
                  )}
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                  <CustomAutoComplete
                    variant="standard"
                    type="text"
                    placeholder="Select Application Number"
                    label="Application Number"
                    autoCompleteValues={applicationArray}
                    value={applicationValue ? applicationValue : null}
                    required={true}
                    onBlur={() => {
                      setApplicationTouched(true);
                    }}
                    onChange={(event, value) => {
                      applicationNumberOnChangeHandler(value);
                    }}
                  />
                  {applicationHasError && (
                    <p className="error">Please Select Application Number</p>
                  )}
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                  <CustomAutoComplete
                    variant="standard"
                    type="text"
                    placeholder="Select Mandate Number"
                    label="Mandate Number"
                    autoCompleteValues={mandateArray}
                    value={mandateValue ? mandateValue : null}
                    required={true}
                    onBlur={() => {
                      setMandateIsTouched(true);
                    }}
                    onChange={(event, value) => {
                      mandateNumberOnChangeHandler(value);
                    }}
                  />
                  {mandateHassError && (
                    <p className="error">Please Select Mandate Number</p>
                  )}
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                  <CustomTextField
                    type="text"
                    required="true"
                    label="UMRN Number"
                    variant="standard"
                    placeholder="UMRN Number"
                    value={umrnNumber === 0 ? "" : umrnNumber}
                    onBlur={() => {
                      setUrmnNumberIsTouched(true);
                    }}
                    onChange={(event, value) => {
                      const inputVal = event.target.value;
                      if (
                        inputVal.length > 0 &&
                        !/^[a-zA-Z0-9]+$/.test(event.target.value) &&
                        event.key !== "Backspace"
                      ) {
                        event.preventDefault();
                      } else {
                        setUmrnNumber(event.target.value);
                      }
                    }}
                  />
                  {umrnNumberHasError && (
                    <p className="error">Please Enter UMRN Number</p>
                  )}
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                  <CustomTextField
                    type="text"
                    label="Applicant Name"
                    variant="standard"
                    placeholder="Applicant Name"
                    disabled={true}
                    value={aprovableData.customerName.toUpperCase()}
                  />
                </Grid>
              </Grid>

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "8px",
                  marginBottom: "4px",
                  gap: "8px",
                }}
              >
                <Tooltip title="Ctrl+F" placement="top">
                  <Button
                    variant="contained"
                    type="submit"
                    sx={{ height: "2rem", fontWeight: "bold" }}
                    onClick={DetailButtonHandler}
                    ref={searchButtonRef}
                  >
                    Detail
                  </Button>
                </Tooltip>

                {!activatedStatus && (
                  <Tooltip title="Ctrl+S" placement="top">
                    <Button
                      variant="contained"
                      type="submit"
                      sx={{ height: "2rem", fontWeight: "bold" }}
                      disabled={saveButtonEnable}
                      onClick={submitButtonOnChangeHandler}
                      ref={saveRef}
                    >
                      {activationState ? "ACTIVATE" : "DEACTIVATE"}
                    </Button>
                  </Tooltip>
                )}
                <Tooltip title="Ctrl+D" placement="top">
                  <Button
                    variant="contained"
                    type="submit"
                    sx={{
                      height: "2rem",
                      fontWeight: "bold",
                      backgroundColor: "black",
                    }}
                    onClick={clearButtonHandler}
                    ref={clearRef}
                  >
                    Clear
                  </Button>
                </Tooltip>
                <Tooltip title="" placement="top">
                  <Button
                    variant="contained"
                    type="submit"
                    sx={{ height: "2rem", fontWeight: "bold" }}
                    onClick={BulkButtonHandler}
                    //ref={searchButtonRef}
                  >
                    Bulk Upload
                  </Button>
                </Tooltip>
                
              </Box>
            </Box>
          </AccordianContainer>
          {/* -----Bulk Upload----- */}
          <Dialog
            open={bulkDlgOpen}
            fullWidth
            maxWidth="md"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle>
              <h4>Bulk Upload Download</h4>
            </DialogTitle>
            <DialogContent>
              {
                <>
                  {loading && (
                    <>
                      <Backdrop
                        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                        open={true}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "8px",
                            alignItems: "center",
                          }}
                        >
                          <CircularProgress color="inherit" />
                          <p>{loadingMsg}</p>
                        </Box>
                      </Backdrop>
                    </>
                  )}
                  <Grid container rowSpacing={0} columnSpacing={2}>
                    <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                      <CustomAutoComplete
                        variant="standard"
                        type="text"
                        placeholder="Select Status"
                        label="Status"
                        autoCompleteValues={actDeact}
                        value={actDeactVal ? actDeactVal : null}
                        required={true}
                        onBlur={() => {
                          setactDeactIsTouched(true);
                        }}
                        onChange={(e, value) => {
                          statusOnChangeHandler(value);
                        }}
                      />
                      {actDeactHasError && (
                        <p className="error">Please Select Status</p>
                      )}
                    </Grid>
                  </Grid>
                </>
              }
            </DialogContent>
            {/* Remove below style if buttons need to placed in right corner */}
            <DialogActions style={{display:'block'}}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "8px",
                  marginBottom: "4px",
                  gap: "8px",
                }}
              >
                <Tooltip title="" placement="top">
                  <Button
                    variant="contained"
                    type="submit"
                    disabled={false}
                    onClick={onClickHandler}
                    sx={{ height: "2rem", fontWeight: "bold" }}
                  >
                    Upload
                    <input hidden id="fileUpload"
                      accept=".xlsx"
                      type="file"
                      onChange={handleUpload} />
                  </Button>
                </Tooltip>
                <Tooltip title="" placement="top">
                  <Button
                    variant="contained"
                    type="submit"
                    disabled={false}
                    onClick={handleDownload}
                  >
                    Download
                  </Button>
                </Tooltip>
                <Tooltip title="" placement="top">
                  <Button
                    variant="contained"
                    type="submit"
                    disabled={false}
                    onClick={handleDwnldVerified}
                  >
                    Download Verified
                  </Button>
                </Tooltip>
                <Tooltip title="" placement="top">
                  <Button
                    variant="contained"
                    type="submit"
                    disabled={false}
                    onClick={handleDwnldActivated}
                  >
                    Download Activated
                  </Button>
                </Tooltip>
                <Tooltip title="" placement="top">
                  <Button
                    onClick={onBulkCancelClick}>
                    CANCEL
                  </Button>
                </Tooltip>
              </Box>
            </DialogActions>
          </Dialog>
          <Snackbar
            open={alert}
            autoHideDuration={3000}
            anchorOrigin={{ vertical, horizontal }}
            onClose={closeAlertHandler}
          >
            <Alert
              onClose={closeAlertHandler}
              severity={alertType}
              variant="filled"
              sx={{ width: "100%" }}
            >
              {message}
            </Alert>
          </Snackbar>
          {/* ------Bulk Upload------ */}
        </Box>
        {showDetailScreen && (
          <Box
            sx={{
              padding: "18px",
              backgroundColor: "white",
              marginTop: "12px",
            }}
          >
            <Grid container spacing={1}>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <CustomTextField
                  type="text"
                  label="NACH Sponsor Bank"
                  variant="standard"
                  placeholder="Enter Nach Sponser Bank"
                  disabled={true}
                  value={mandateDetails.nachSponserBank}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <CustomTextField
                  type="text"
                  label="IFSC"
                  variant="standard"
                  placeholder="Enter IFSC"
                  disabled={true}
                  value={mandateDetails.ifsc}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <CustomTextField
                  type="text"
                  label="MICR"
                  variant="standard"
                  placeholder="Enter MICR"
                  disabled={true}
                  value={mandateDetails.micr}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <CustomTextField
                  type="text"
                  label="Drawee Bank"
                  variant="standard"
                  placeholder="Enter Drawee Bank"
                  disabled={true}
                  value={mandateDetails.draweeBank}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <CustomTextField
                  type="text"
                  label="Branch Name"
                  variant="standard"
                  placeholder="Enter Branch Name"
                  disabled={true}
                  value={mandateDetails.branchName}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <CustomTextField
                  type="text"
                  label="Bank Account Number"
                  variant="standard"
                  placeholder="Enter Bank Account Number"
                  disabled={true}
                  value={mandateDetails.accountNumber}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <CustomTextField
                  type="text"
                  label="Account Holder Name"
                  variant="standard"
                  placeholder="Enter Account Holder Name"
                  disabled={true}
                  value={mandateDetails.accountHolderName}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <CustomTextField
                  type="text"
                  label="NACH Amount (₹)"
                  variant="standard"
                  placeholder="Enter Nach Amount"
                  disabled={true}
                  value={parseFloat(mandateDetails.nachAmt).toLocaleString(
                    "en-IN"
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <CustomTextField
                  type="text"
                  label="Mandate Amount"
                  variant="standard"
                  placeholder="Enter Mandate Amount"
                  disabled={true}
                  value={parseFloat(mandateDetails.mandateAmt).toLocaleString(
                    "en-IN"
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <CustomTextField
                  type="text"
                  label="Frequency"
                  variant="standard"
                  placeholder="Enter Frequency"
                  disabled={true}
                  value={mandateDetails.frequency}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <CustomDateField
                  label="File FBD"
                  variant="standard"
                  placeholder="Enter File FBD"
                  disabled={true}
                  value={mandateDetails.fileFBD}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <CustomDateField
                  label="Mandate Start Date"
                  variant="standard"
                  placeholder="Enter Mandate Start Date"
                  disabled={true}
                  value={mandateDetails.mandateStartDate}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <CustomDateField
                  label="First NACH Billing Date"
                  variant="standard"
                  placeholder="Enter First Nach Billing Date"
                  disabled={true}
                  value={mandateDetails.firstNachBillingDate}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <CustomTextField
                  type="text"
                  label="Mandate Validity"
                  variant="standard"
                  placeholder="Enter Mandate Validity"
                  disabled={true}
                  value={mandateDetails.mandateValidity}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <CustomDateField
                  label="Mandate End Date"
                  variant="standard"
                  placeholder="Enter Mandate End Date"
                  disabled={true}
                  value={mandateDetails.mandateEndDate}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <CustomTextField
                  label="Debit Type"
                  variant="standard"
                  placeholder="Enter Debit Type"
                  disabled={true}
                  value={mandateDetails.debitType}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <CustomTextField
                  label="Status"
                  variant="standard"
                  placeholder="Enter Status"
                  disabled={true}
                  value={mandateDetails.status}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <CustomTextField
                  label="Customer Mobile Number"
                  variant="standard"
                  placeholder="Enter Moile Number"
                  disabled={true}
                  value={mandateDetails.mobileNumber}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <CustomTextField
                  label="Customer Email ID"
                  variant="standard"
                  placeholder="Enter Email ID"
                  disabled={true}
                  value={mandateDetails.email}
                />
              </Grid>
              {!activationState && showDEActivatedFlag && (
                <>
                  <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                    <CustomDateField
                      label="Deactivation Date"
                      variant="standard"
                      placeholder="Enter Deactivation Date"
                      value={aprovableData.deactivationDate}
                      disabled={activatedStatus}
                      disablePast={true}
                      required={true}
                      maxDate={new Date().setDate(
                        new Date().getDate() + maxDateAddValue
                      )}
                      onChange={(value) => {
                        const maxValue = new Date().setDate(
                          new Date().getDate() + maxDateAddValue
                        );
                        const specialAccessFlag =
                          new Date(value).toDateString() >
                          new Date(maxValue).toDateString();
                        if (!specialAccessFlag) {
                          setSpecialAccessCheck(false);
                          dispatch(
                            NachApprovalReducerAction.updateDeactivationDate(
                              value
                            )
                          );
                        } else {
                          setSpecialAccessCheck(true);
                        }
                      }}
                      onBlur={() => {
                        setDeactivationDateIsTouched(true);
                      }}
                    />
                    {deactivationDateHasError && (
                      <p className="error">
                        Please Enter Valid Deactivation Date
                      </p>
                    )}
                    {specialAccessCheck && (
                      <p className="error">
                        Please Enter Valid Deactivation Date
                      </p>
                    )}
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                    <div>
                      <InputLabel
                        required="true"
                        size="small"
                        sx={{
                          color: "#004A92",
                          mb: 2,
                          fontWeight: 400,
                          fontSize: "14px",
                        }}
                      >
                        Deactivation Reason
                      </InputLabel>
                      <Tooltip
                        title={aprovableData.deactivationReason}
                        placement="top"
                      >
                        <TextField
                          autoComplete="off"
                          fullWidth
                          variant="standard"
                          value={aprovableData.deactivationReason}
                          type="text"
                          placeholder="Enter Deactivation Reason"
                          disabled={activatedStatus}
                          onChange={(e) => {
                            dispatch(
                              NachApprovalReducerAction.updateDeactivationReason(
                                e.target.value
                              )
                            );
                          }}
                          onBlur={() => {
                            setDeactivationReasonIsTouched(true);
                          }}
                        />
                      </Tooltip>
                      {/* </Stack> */}
                    </div>

                    {deactivationReasonHasError && (
                      <p className="error">
                        Please Enter Valid Deactivation Reason
                      </p>
                    )}
                  </Grid>
                </>
              )}
            </Grid>
          </Box>
        )}
      </Box>
      <StlapFooter />

      <Dialog
        open={confirmationDialogOpen}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Confirmation</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {` ${activationState ? "Activate" : "Deactivate"} NACH Mandate ?`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Tooltip title="Ctrl+Q" placement="top">
            <Button onClick={confirmationDialogClose} ref={cancelRef}>
              Cancel
            </Button>
          </Tooltip>
          <Tooltip title="Ctrl+Y" placement="top">
            <Button
              onClick={confirmationDialogOkButtonClickHandler}
              ref={yesRef}
            >
              Yes
            </Button>
          </Tooltip>
        </DialogActions>
      </Dialog>
      <Dialog
        open={sucessDialogOpen}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{successTitle}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {successDialogMessage}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Tooltip title="Ctrl+K" placement="top">
            <Button
              onClick={() => {
                setSuccessDialogOpen(false);
              }}
              ref={okRef}
            >
              OK
            </Button>
          </Tooltip>
        </DialogActions>
      </Dialog>
      <Dialog
        open={editLockDialogOpen}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>Information</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            This Record is Being Edited by Other User, Click OK to Navigate View
            Screen.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Tooltip title="Ctrl+K" placement="top">
            <Button
              onClick={() => {
                editLockOkButonHandler();
              }}
              ref={okEditRef}
            >
              OK
            </Button>
          </Tooltip>
        </DialogActions>
      </Dialog>
      <Dialog open={resetDialogHandler}>
        <DialogTitle>
          <h4>Confirmation</h4>
        </DialogTitle>
        <DialogContent>Data Will be Reset to Default ?</DialogContent>
        <DialogActions>
          <Tooltip title="Ctrl+Q" placement="top">
            <Button
              onClick={() => {
                setResetDialogHandler(false);
              }}
              ref={cancelResetRef}
            >
              Cancel
            </Button>
          </Tooltip>
          <Tooltip title="Ctrl+K" placement="top">
            <Button onClick={onOkButtonClickHandler} ref={okResetRef}>
              OK
            </Button>
          </Tooltip>
        </DialogActions>
      </Dialog>
      <CustomConfirmationDialog
        dialogOpen={accessDialogOpen}
        dialogTitle={
          <Typography sx={{ fontSize: "1.25rem" }}>Information</Typography>
        }
        dialogContent={
          <>
            <Typography sx={{ fontSize: "1rem" }}>
              Access Not Given to this User, Click OK to Navigate View Screen.
            </Typography>
          </>
        }
        hideCancelButton={true}
        okButtonName={"OK"}
        cancelButtonName={""}
        onOkClick={accessDialogClickHandler}
      />
    </React.Fragment>
  );
};

export default NachActiveDeactive;
